var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11399 4.13649C3.76252 3.78502 3.76252 3.21517 4.11399 2.8637C4.46547 2.51223 5.03532 2.51223 5.38679 2.8637L13.8868 11.3637C14.2383 11.7152 14.2383 12.285 13.8868 12.6365L5.38679 21.1365C5.03532 21.488 4.46547 21.488 4.11399 21.1365C3.76252 20.785 3.76252 20.2152 4.11399 19.8637L11.9776 12.0001L4.11399 4.13649Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.114 4.13649C9.76252 3.78502 9.76252 3.21517 10.114 2.8637C10.4655 2.51223 11.0353 2.51223 11.3868 2.8637L19.8868 11.3637C20.2383 11.7152 20.2383 12.285 19.8868 12.6365L11.3868 21.1365C11.0353 21.488 10.4655 21.488 10.114 21.1365C9.76252 20.785 9.76252 20.2152 10.114 19.8637L17.9776 12.0001L10.114 4.13649Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleRight);
export default __webpack_public_path__ + "static/media/double-right.91a16bdd0dd630afad56d49b907f2a78.svg";
export { ForwardRef as ReactComponent };